import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import { validateField } from "../../utils/validation/validation";
import InputField from "../../utils/InputField";
import TextAreaField from "../../utils/TextAreaField";
import Dropzone from "../../utils/dropzone";
import GoogleMapsWrapper from '../../utils/GoogleMapsWrapper';
import PlaceComponent from "../Address/AddressAutoPop";

const LocationForm = React.memo(({ data, onChange, onValidate, errors, isFrom = "page", disabled = false }) => {
  const [selectedOption, setSelectedOption] = useState('uploadPDF');

  const handleChange = (field, value) => {
    if (disabled) return;
    onChange(field, value);
    const error = validateField(field, value);
    onValidate(field, error);
  };

  const handleFileUpload = (fieldName, uploadedFiles) => {
    if (disabled) return;
    console.log("Files uploaded to field:", fieldName, uploadedFiles);
    onChange(fieldName, uploadedFiles);
  };

  const handleOptionChange = (e) => {
    if (disabled) return;
    setSelectedOption(e.target.value);
  };

  return (
    <Container className="px-0" fluid>
      <Row className="no-gutters">
        <Col sm={isFrom === "page" ? 5 : 12}>
          <div className="form-wrapper rounded">
            <Row className="mb-3">
              <div className="form-heading mt-4 mb-4 text-uppercase">Work Location Address</div>
              <GoogleMapsWrapper>
                <PlaceComponent
                  field="address"
                  label="Location Address"
                  className="mb-3"
                  value={data.address}
                  onChange={handleChange}
                  type="text"
                  error={errors.address}
                  controlId="location"
                  disabled={disabled}
                />
              </GoogleMapsWrapper>
            </Row>
          </div>
        </Col>

        <Col sm={isFrom === "page" ? 7 : 12}>
          <div className="form-wrapper rounded">
            <div className="form-heading mb-4 text-uppercase fw-bold">Project Information</div>
            <Row className="mb-3">
              <InputField
                field="permitType"
                label="Commercial Permit Type"
                value={data.permitType}
                onChange={handleChange}
                error={errors.permitType}
                type="select"
                options={["New Construction", "Exterior Remodel", "Interior Remodel", "Building Work Only (Non-Structural)", "Building Work Only", "Electric Only", "Mechanical Only", "Plumbing Only","Sign Only"]}
                as={Col}
                controlId="location"
                disabled={disabled}
              />
            </Row>
            <Row className="mb-3">
              <TextAreaField
                field="description"
                label="Work Description"
                value={data.description}
                onChange={handleChange}
                error={errors.description}
                as={Col}
                controlId="location"
                placeholder=""
                disabled={disabled}
              />
            </Row>
            <Row className="mb-3">
              <InputField
                field="cost"
                label="Cost of Construction"
                value={data.cost}
                onChange={handleChange}
                error={errors.cost}
                as={Col}
                allowCommas={true}
                showDollarSign={true}
                placeholder=""
                controlId="location"
                disabled={disabled}
              />
            </Row>
          </div>
        </Col>

        {!disabled && (
          <Col sm="12">
            <div className="form-wrapper rounded mt-5">
              <div className="form-heading text-uppercase fw-bold">
                Construction documents, Plans, or Specifications (Only PDF)
              </div>
              <div className='mt-3 d-flex align-items-center' style={{ gap: '20px' }}>
                <label className="d-flex align-items-center mb-0" style={{ cursor: 'pointer', gap: '8px' }}>
                  <input
                    type="radio"
                    value="uploadPDF"
                    checked={selectedOption === 'uploadPDF'}
                    onChange={handleOptionChange}
                    style={{ margin: 0, cursor: 'pointer' }}
                  />
                  <span>Upload PDF</span>
                </label>
                <label className="d-flex align-items-center mb-0" style={{ cursor: 'pointer', gap: '8px' }}>
                  <input
                    type="radio"
                    value="pdfUrl"
                    checked={selectedOption === 'pdfUrl'}
                    onChange={handleOptionChange}
                    style={{ margin: 0, cursor: 'pointer' }}
                  />
                  <span>Paste Your URL</span>
                </label>
              </div>
              <div>
                {selectedOption === 'uploadPDF' && (
                  <div>
                    <Dropzone 
                      fileTypes={["application/pdf"]} 
                      showPreview={true} 
                      fieldName="locationFiles" 
                      onFileUpload={handleFileUpload}
                      maxFileSizeMB={250}
                    />
                  </div>
                )}
                {selectedOption === 'pdfUrl' && (
                  <div className='my-3'>
                    <Row className="mb-3">
                      <InputField
                        field="locationFileUrl"
                        label="Paste Your URL"
                        value={data.locationFileUrl || ''}
                        onChange={handleChange}
                        as={Col}
                        controlId="location"
                      />
                    </Row>
                    <div className="my-2">
                      Please enter a valid PDF URL with https:// or http:// .
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Col>
        )}
      </Row>
    </Container>
  );
});

export default LocationForm;
